module.exports = __webpack_public_path__ + "static/img/27.74f46d94.png";